import { useQuery } from '@tanstack/react-query';
import uuid from 'react-uuid';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

export interface ClientResponse {
  clientId: number;
  name: string;
  isDeleted: boolean;
  rowId: string;
}

async function fetchClients(companyId: string): Promise<ClientResponse[]> {
  const res = await axiosInstance.get<ClientResponse[]>(api.client(companyId));
  return res.data.map((member) => ({ ...member, rowId: uuid() }));
}

export function useGetClientsQuery(companyId: string) {
  return useQuery({
    queryKey: queryKeys.company.clients(companyId),
    queryFn: () => fetchClients(companyId),
    enabled: Boolean(companyId),
  });
}
